/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { fetchSectorPerformance} from "../../api";

const SectorPerformance = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
              fetchSectorPerformance()
                  .then((data) => setData(data))
                  .catch((error) => console.error("Error fetching market breadth:", error));
    };

    fetchData();
  }, []);

  if (data.length === 0) return <p>Loading sector data...</p>;

  // ✅ Extract Data for Charts
  const sectors = data.map((item) => item.sector_symbol);
  const change1D = data.map((item) => item.change_1d);
  const changeYTD = data.map((item) => item.change_ytd);
  const colors = changeYTD.map((val) => (val > 0 ? "green" : "red"));

  // ✅ Inline CSS Styles
  const styles = {
    container: {
      padding: "16px",
      fontFamily: "Arial, sans-serif",
    },
    chartContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "space-between",
      marginTop: "20px",
    },
    chartBox: {
      flex: 1,
      minWidth: "400px",
      padding: "10px",
      border: "1px solid #ddd",
      borderRadius: "10px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      backgroundColor: "white",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      background: "#065e96",
      padding: "8px",
      borderBottom: "2px solid #ddd",
      textAlign: "left",
      color: "white"
    },
    td: {
      padding: "8px",
      borderBottom: "1px solid #ddd",
    },
  };

  return (
    <div style={styles.container}>
      <h2>Sector Performance</h2>

      <div style={styles.chartContainer}>
        {/* ✅ Sector Performance Bar Chart */}
        <div style={styles.chartBox}>
          <Plot
            data={[
              {
                x: sectors,
                y: changeYTD,
                type: "bar",
                marker: { color: colors },
              },
            ]}
            layout={{ title: "Sector % Change (YTD)", height: 400, width: 500 }}
          />
        </div>

        {/* ✅ Sector Heatmap */}
        <div style={styles.chartBox}>
          <Plot
            data={[
              {
                x: sectors,
                y: ["% Change"],
                z: [changeYTD],
                type: "heatmap",
                colorscale: [
                  ["0.0", "red"],
                  ["0.5", "yellow"],
                  ["1.0", "green"],
                ],
              },
            ]}
            layout={{ title: "Sector Heatmap", height: 400, width: 500 }}
          />
        </div>
      </div>
        {/* ✅ Sector Performance Table */}
      <div style={styles.chartContainer}>

        <div style={styles.chartBox}>
          <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Sector</th>
              <th style={styles.th}>% Change (1D)</th>
              <th style={styles.th}>% Change (YTD)</th>
              <th style={styles.th}>Top Gainers</th>
              <th style={styles.th}>Top Losers</th>
            </tr>
          </thead>
          <tbody>
            {data.map((sector, index) => (
              <tr key={index}>
                <td style={styles.td}>{sector.sector_symbol}</td>
                <td style={styles.td}>{sector.change_1d}%</td>
                <td style={styles.td}>{sector.change_ytd}%</td>
                <td style={styles.td}>{sector.top_gainers}</td>
                <td style={styles.td}>{sector.top_losers}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default SectorPerformance;
